import { googleLogout } from "@react-oauth/google";
import { logoutCreate } from "../api-client/logout/logout";
import { queryClient } from "../lib/queryClient";

export default function useLogout() {

  return async () => {
    googleLogout();

    try {
      if (typeof localStorage?.clear === "function") {
        localStorage.clear();
      }
    } catch {
      // ignore storage errors
    }

    try {
      await logoutCreate();
    } catch (error) {
      // log but continue logout flow
      console.error("Error during logout:", error);
    }

    // Clear all TanStack Query cache
    queryClient.clear();
    // Cause a reload to clear cache and refetch variables
    window.location.pathname = "/login";
  };
}
